var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "share"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18 16.12C17.24 16.12 16.56 16.42 16.04 16.89L8.91 12.74C8.96 12.51 9 12.28 9 12.04C9 11.8 8.96 11.57 8.91 11.34L15.96 7.23001C16.5 7.73001 17.21 8.04001 18 8.04001C19.66 8.04001 21 6.70001 21 5.04001C21 3.38001 19.66 2.04001 18 2.04001C16.34 2.04001 15 3.38001 15 5.04001C15 5.28001 15.04 5.51001 15.09 5.74001L8.04 9.85001C7.5 9.35001 6.79 9.04001 6 9.04001C4.34 9.04001 3 10.38 3 12.04C3 13.7 4.34 15.04 6 15.04C6.79 15.04 7.5 14.73 8.04 14.23L15.16 18.39C15.11 18.6 15.08 18.82 15.08 19.04C15.08 20.65 16.39 21.96 18 21.96C19.61 21.96 20.92 20.65 20.92 19.04C20.92 17.43 19.61 16.12 18 16.12ZM18 4.04001C18.55 4.04001 19 4.49001 19 5.04001C19 5.59001 18.55 6.04001 18 6.04001C17.45 6.04001 17 5.59001 17 5.04001C17 4.49001 17.45 4.04001 18 4.04001ZM6 13.04C5.45 13.04 5 12.59 5 12.04C5 11.49 5.45 11.04 6 11.04C6.55 11.04 7 11.49 7 12.04C7 12.59 6.55 13.04 6 13.04ZM18 20.06C17.45 20.06 17 19.61 17 19.06C17 18.51 17.45 18.06 18 18.06C18.55 18.06 19 18.51 19 19.06C19 19.61 18.55 20.06 18 20.06Z",
    fill: "#161616"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileShareIcon);
export default __webpack_public_path__ + "static/media/file-share-icon.3d2b28d7d7a295f027c71e2044d8e856.svg";
export { ForwardRef as ReactComponent };